<template>
  <el-tabs type="border-card" v-model="tabName" @tab-change="fetch">
    <el-tab-pane label="渠道汇总" name="storedata" class="horizbox" lazy>
      <StoreData ref="storedata" @set-sku="setSkuCode" />
    </el-tab-pane>
    <el-tab-pane label="渠道报表" name="storechart" lazy>
      <StoreChart ref="storechart" />
    </el-tab-pane>
    <el-tab-pane label="款式报表" name="detaildata" lazy>
      <DetailData ref="detaildata" @set-sku="setSkuCode" />
    </el-tab-pane>
    
    <el-tab-pane label="退货报表" name="returndata" lazy>
      <ReturnData ref="returndata" />
    </el-tab-pane>
    <el-tab-pane label="月度周转" name="monthSaleRemain" lazy>
      <MonthSaleRemain ref="monthSaleRemain" />
    </el-tab-pane>
  </el-tabs>

  <!-- SKU详情 -->
  <div class="xlsdialog">
    <el-dialog title="SKU详情" v-model="skuDetailDialogVisible" :show-close="true" :close-on-click-modal="false"
      destroy-on-close top="5vh" @closed="skuDetailDialogVisible = false" width="60%" center>
      <skudetail :detailCode="detailCode"></skudetail>
    </el-dialog>
  </div>

  <static-dialog ref="resetDialog" class="dialog" title="密码过于简单，请重置默认密码">
    <resetPwdDialog :visible="true" ref="resetPwdDialogRef"></resetPwdDialog>
  </static-dialog>
</template>

<script>
import * as echarts from 'echarts';
import StaticDialog from "@/components/static-dialog.vue";
import { consoleBlocks, consoleTable, getRangeTime, consoleExport } from "@/api/console";
import skudetail from "../stock/product/skudetail.vue";
import resetPwdDialog from "@/views/sys/user/reset.vue";
import request from '@/utils/request'
import StoreData from './console-tabs/StoreData.vue'
import StoreChart from './console-tabs/StoreChart.vue'
import DetailData from './console-tabs/DetailData.vue'
import ReturnData from './console-tabs/ReturnData.vue'
import MonthSaleRemain from './console-tabs/MonthSaleRemain.vue'

export default {
  name: "console",
  components: { skudetail, resetPwdDialog, StaticDialog, StoreData, StoreChart, DetailData, ReturnData, MonthSaleRemain },
  data() {
    return {
      tabName: "storedata",

      apiUrl: "",
      //数据版
      blocks: {},
      //仓库
      store: [],
      value: "全部",
      //部门
      channels: [],
      brands: [],
      value2: "全部",

      //时间范围
      valueTime: [],
      //表单params
      paramsObj: {
        keyword: '',
        companyId: '',
        storeCode: "",
        channel: "",
        brand: '',
        startDate: "",
        endDate: "",
      },
      //回传数据
      tableData: [],
      //周转率
      tockNumberTurnoverRateTotalValue: "0",

      skuDetailDialogVisible: false,
      detailCode: '',

      //resetDialogVisible: false,
      companys: [],

      storedata: [],
      returnChannelData: [],
      returnProductData: [],
    };
  },
  methods: {
    fetch(tab) {
      const name = (tab && tab.name) || this.tabName;
      this.$nextTick(() => {
        if (name === 'detaildata' && this.$refs.detaildata && this.$refs.detaildata.fetch) this.$refs.detaildata.fetch();
        else if (name === 'storechart' && this.$refs.storechart && this.$refs.storechart.fetch) this.$refs.storechart.fetch();
        else if (name === 'storedata' && this.$refs.storedata && this.$refs.storedata.fetch) this.$refs.storedata.fetch();
        else if (name === 'returndata' && this.$refs.returndata && this.$refs.returndata.fetch) this.$refs.returndata.fetch();
        else if (name === 'monthSaleRemain' && this.$refs.monthSaleRemain && this.$refs.monthSaleRemain.fetch) this.$refs.monthSaleRemain.fetch();
      });
    },
    //获取概览数据
    // NOTE: moved data-request and format helpers into child components.

    setSkuCode(row) {
      this.skuDetailDialogVisible = true;
      this.detailCode = row.detailCode;
    },

    // getStoreTable moved into `StoreChart.vue` child

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index >= 9) return;

        if (index === 0) {//只找第一列放合计
          sums[index] = '合计';
          return;
        }

        //把对应一列中的之全部取出，放到一个数组中
        const values = data.map(item => Number(item[column.property]));
        //如果el-table-column中没有prop属性，这里的column.property是undefined，所以判断一下values数组是否为空
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            //console.log(prev, curr);
            //将values中的每个值转换为number类型
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // if (index == 12) {
          //   sums[index] = '';
          // }
          sums[index] = this.$util.fmtMoney(sums[index] || '');
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
  created() {
    this.$kaung.companys().then((res) => {
      this.companys = res;
      //this.paramsObj.companyId = res[0].id;

      //this.valueTime = this.$util.getCurrentDate('month'); //this.rangeTime("month");

      //this.fetch();
    });

    this.apiUrl = process.env.VUE_APP_BASEURL;

    //this.forms.account = this.$store.getters.getUserInfo.name;
  },
  mounted() {
    //console.log(this.$route.query.type)
    if (this.$route.query.type == 'simple') {
      this.$message.error("密码过于简单，请重置默认密码");
      //this.$emit('openPwd');
      //this.resetDialogVisible = true;
      this.$refs.resetDialog.toggle();
    }

    this.$kaung.dictionary("stock", "store").then(res => this.store = res);
    this.$kaung.dictionary("stock", "channel").then(res => this.channels = res);
    this.$kaung.dictionary("stock", "brand").then(res => this.brands = res);
    this.fetch();
  }
};
</script>

<style scoped>
.console-page { padding: 0; }
</style>
 
